// Load css file
const loadCss = (fileName) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    const fileId = `${fileName.toUpperCase()?.replace('-', '')}CSS`;
    const mainPath = document.getElementById('MainCssPath').href;
    link.onload = resolve;
    link.onerror = reject;
    link.id = fileId;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = mainPath.includes('?v')
      ? mainPath.split('?v')[0]?.replace('/assets/main.css', `/assets/${fileName}.css`)
      : mainPath.replace('/assets/main.css', `/assets/${fileName}.css`);
    link.media = 'all';
    if (!document.getElementById(fileId)) {
      document.head.appendChild(link);
    }
  });
};
// Load js file
const loadScript = (fileName) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    const fileId = `${fileName.toUpperCase()?.replace('-', '')}JS`;
    const mainPath = document.getElementById('MainJsPath').src;
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.id = fileId;
    script.type = 'text/javascript';
    script.src = mainPath.includes('?v')
      ? mainPath.split('?v')[0]?.replace('/assets/main.js', `/assets/${fileName}.js`)
      : mainPath.replace('/assets/main.js', `/assets/${fileName}.js`);
    if (!document.getElementById(fileId)) {
      document.head.appendChild(script);
    }
  });
};
// Scroll animation observer
const scrollAnimationObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-animation--active');
        scrollAnimationObserver.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.25,
  }
);

(function scrollAnimationInit() {
  if (!document.documentElement.classList.contains('js-animations--accent')) return;

  document.querySelectorAll('.scroll-animation').forEach((el, i) => {
    scrollAnimationObserver.observe(el);
  });
})();
// Add helper class when announcement bar is enabled
window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.announcement-bar') != null) {
    document.body.classList.add('is-announcement-bar');
  }
});
// Helper functions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
// Details animation
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.classList.remove('details--active');
  summaryElement.setAttribute('aria-expanded', false);
  setTimeout(() => {
    openDetailsElement.removeAttribute('open');
  }, 500);
  if (summaryElement.classList.contains('mmenu__hamburger') && document.body.classList.contains('mmenu--open')) {
    document.body.classList.remove('mmenu--open');
  }
  summaryElement.focus();
}
class Accordion {
  constructor(el) {
    this.details = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.details__content');

    this.summary.addEventListener('click', (event) => this.onClick(event));
    this.details.addEventListener('keyup', onKeyUpEscape);
    window.addEventListener('DOMContentLoaded', this.mobileOnlyDetails());
  }

  onClick(event) {
    event.preventDefault();
    event.currentTarget.setAttribute('aria-expanded', !this.details.hasAttribute('open'));

    if (this.details.hasAttribute('open')) {
      this.collapse();
    } else {
      this.expand();
    }

    if (this.summary.classList.contains('mmenu__hamburger')) {
      document.body.classList.toggle('mmenu--open');
    }
  }

  collapse() {
    this.details.classList.remove('details--active');
    setTimeout(() => {
      this.details.removeAttribute('open');
    }, 10);
  }

  expand() {
    this.details.setAttribute('open', '');
    setTimeout(() => {
      this.details.classList.add('details--active');
    }, 10);
  }

  mobileOnlyDetails() {
    if (this.details.classList.contains('mobile--only')) {
      if (window.innerWidth < 769) {
        this.collapse();
      } else {
        this.expand();
      }
    }
  }
}
document.querySelectorAll('[id^="Details-"]').forEach((el) => {
  new Accordion(el);
});
// Mobile menu dropdowns
(() => {
  const mmenu = document.querySelectorAll('.mmenu-drawer details.details--active:not(:has(.link-styled--active))').forEach((el) => {
    el.classList.remove('details--active');
    el.removeAttribute('open');
  });
})();
// Check if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}
// Section carousel
document.addEventListener('DOMContentLoaded', function () {
  const sectionSlider = document.querySelectorAll('.section-slider .splide');
  if (sectionSlider) {
    sectionSlider.forEach((target) => {
      const splide = new Splide(target).mount();

      slideshows.push(splide);

      if (target.classList.contains('splide__pagination--counter') && target.classList.contains('splide--ltr')) {
        splide.on('autoplay:playing', function (rate) {
          const activePagination = document.querySelector(
            '.section-slider .splide__pagination--counter .splide__pagination--ltr .splide__pagination__page.is-active'
          );
          if (activePagination) activePagination.style.width = `${rate * 100}%`;
        });
      }
    });
  }
});
// Variant select
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateMetafields();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const variantImage = this.currentVariant.featured_media.preview_image.src;

    if (this.closest('.product-card')) {
      const media = this.closest('.product-card').querySelector('.product-card__media .media--primary');
      media.innerHTML = `<img src="${variantImage}&width=1440">`;
    } else {
      const carousel = document.querySelector('#main-carousel');
      if (!carousel) return;
      const media = carousel.querySelector(
        `.splide__slide[data-media-position="${this.currentVariant.featured_media.position}"]`
      );
      const mediaContainer = carousel.querySelector('.splide__list');

      if (carousel.classList.contains('is-active')) {
        var Slides = main.Components.Slides.filter('.product__media-item');

        if (Slides[this.currentVariant.featured_media.position - 1]) {
          if (carousel.classList.contains('splide--loop')) {
            main.go(Slides[this.currentVariant.featured_media.position + 1].index);
          } else {
            main.go(Slides[this.currentVariant.featured_media.position - 1].index);
          }
        }
      } else {
        media.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      }
    }    
  }

  updatePicture(pictureSelector, newUrl) {
    const picture = document.querySelector(pictureSelector);
    if (!picture) return;
        
    const img = picture.querySelector('img');
    if (img) img.src = newUrl;
    
    picture.querySelectorAll('source').forEach(source => {      
      source.srcset = newUrl;      
    });    
  }

  updateMetafields() {    
    const productData = JSON.parse(document.getElementById('ProductData').textContent);

    if (!this.currentVariant) return;
    if (!productData?.variants) return;    

    const variantId = this.currentVariant.id.toString();    
    const matchedVariant = productData.variants.find(v => v.id === variantId);
  
    if (matchedVariant) {      
      // Update frame color in product title
      const frame_color = matchedVariant.metafields["jmm.frame_color"];
      document.querySelectorAll('.frame-color').forEach(el => {
        el.textContent = frame_color;
      })
      // Update variant images      
      const image1 = matchedVariant.metafields["jmm.image_detail_1"]?.url;
      const image2 = matchedVariant.metafields["jmm.image_detail_2"]?.url;
      const image3 = matchedVariant.metafields["jmm.image_detail_3"]?.url;
      const image_3_4 = matchedVariant.metafields["jmm.image_3_4"]?.url;      
      
      this.updatePicture('.variant-image-1 picture', image1);
      this.updatePicture('.variant-image-2 picture', image2);
      this.updatePicture('.variant-image-3 picture', image3);

      document.querySelectorAll('.side-view__container').forEach(el => {        
        el.querySelector('img')?.setAttribute('src', image_3_4);
      })      

      // Update limited quantity
      const limitedQty = matchedVariant.metafields["jmm.serial_number"];
      document.querySelectorAll('.limitedQty').forEach(el => {
        el.textContent = limitedQty;
      })     
      
      // Update package care
      const packaging_description = matchedVariant.metafields["jmm.packaging_description"];
      if(packaging_description){
        document.querySelector('#packageCare').innerHTML = packaging_description;
      }            

      // Update preoder date
      if(document.getElementById('PreorderProperty')) {
        const preorder = document.getElementById('PreorderProperty');
        const availability = matchedVariant.metafields["jmm.item_availability"];
        const preoder_date = matchedVariant.metafields["jmm.preorder_date"];

        if(availability == 'PRE-ORDER') {
          preorder.setAttribute('name', 'properties[Preorder]');          
          preorder.value = preoder_date; 
        } else {
          preorder.removeAttribute('name');
          preorder.value = ''; 
        }
      }

      // Update variant details
      const materials = matchedVariant.metafields["jmm.materials"];
      const coating = matchedVariant.metafields["jmm.coating"];
      const base = matchedVariant.metafields["jmm.base"];
      const transmission_rate = matchedVariant.metafields["jmm.transmission_rate"];
      const category = matchedVariant.metafields["jmm.category"];
      const uv_protection = matchedVariant.metafields["jmm.uv_protection"];
      const variant_details = matchedVariant.metafields["jmm.variant_details"].split('\n');
      const composition_description = matchedVariant.metafields["jmm.composition_description"];      

      if(document.getElementById('Materials') != null) {
        document.getElementById('Materials').textContent = materials; 
      }
      if(document.getElementById('Coating') != null) {
        document.getElementById('Coating').textContent = coating; 
      }
      if(document.getElementById('Base') != null) {
        document.getElementById('Base').textContent = base; 
      }
      if(document.getElementById('TransmissionRate') != null) {
        document.getElementById('TransmissionRate').textContent = transmission_rate; 
      }
      if(document.getElementById('Category') != null) {
        document.getElementById('Category').textContent = category; 
      }
      if(document.getElementById('UVProtection') != null) {
        document.getElementById('UVProtection').textContent = uv_protection;       
      }

      const compositionDescription = document.querySelector('.product-details__description .h2');      
      if(composition_description) {
        compositionDescription.innerHTML = composition_description.toLowerCase();      
      }      

      const variantDetailsList = document.getElementById('VariantDetails');      
      variantDetailsList.innerHTML = '';
      
      variant_details.forEach((detail) => {
        if (typeof detail === 'string') {
          const li = document.createElement('li');
          li.textContent = detail.trim();
          variantDetailsList.appendChild(li);
        }
      });      
    }

  }

  updateURL() {
    if (!this.closest('.product-wrapper') || !this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    const urlInput = shareButton.querySelector('input');
    let urlToShare = urlInput ? urlInput.value : document.location.href;
    const url = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
    urlToShare = url;
    urlInput.value = url;
  }

  updateVariantInput() {
    if (this.closest('.product-card')) {
      if (this.closest('form')) {
        const productCardInput = this.closest('form').querySelector('input[name="id"]');
        productCardInput.value = this.currentVariant.id;
        productCardInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);

      // Update slected option label
      this.querySelectorAll(':checked').forEach((el) => {
        if (el.closest('.product-form__input').querySelector('#selectedOption')) {
          el.closest('.product-form__input').querySelector('#selectedOption').textContent = el.value;
        }
      });
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.style.display = 'block';
    } else {
      pickUpAvailability.style.display = 'none';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url.split('?')[0]}.json`)
      .then((response) => response.json())
      .then((data) => {
        const variant = data.product.variants.filter((v) => {
          return v.id === this.currentVariant.id;
        });
        
        const priceText = document.querySelectorAll('.price-item')[0].textContent.trim();        

        // Extract currency code (EUR, USD, GBP, etc)
        const currencyMatch = priceText.match(/\b[A-Z]{3}\b/);
        const currency = currencyMatch ? currencyMatch[0] : "";        

        // Extract amount
        const amountMatch = priceText.match(/[\d.,]+/);
        const amount = amountMatch ? amountMatch[0] : "";

        // Extract ONLY the symbol (non-digit chars BEFORE or AFTER the amount)
        let symbol = priceText
          .replace(amount, "")
          .replace(currency, "")
          .trim();

        // Remove extra spaces
        symbol = symbol.replace(/\s+/g, "");

        // Ensure we keep only printable non-alphanumeric (€, $, £, etc.)
        symbol = symbol.replace(/[A-Za-z0-9]/g, "");
        
        let price, compare_price, saleBadge;
        const soldOutBadge = document.querySelector('.product-wrapper .badge--sold');
        let compare_at_price = variant[0].compare_at_price;
        if (compare_at_price != '') {
          compare_at_price = symbol + variant[0].compare_at_price + ' ' + currency;
        }

        if (this.closest('.product-card')) {
          price = this.closest('.product-card').querySelector('.price-item--regular');
          compare_price = this.closest('.product-card').querySelector('.price-item--compare');
          saleBadge = this.closest('.product-card').querySelector('.badge--sale');
        } else {
          price = this.closest('.product-wrapper').querySelector('.price-item--regular');
          compare_price = this.closest('.product-wrapper').querySelector('.price-item--compare');
          saleBadge = this.closest('.product-wrapper').querySelector('.badge--sale');
        }

        if (price.closest('.price').querySelector('.price-varies__label')) {
          price.closest('.price').querySelector('.price-varies__label').remove();
        }

        const locale = document.documentElement.dataset.locale;
        const formatted = new Intl.NumberFormat(locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(variant[0].price);

        const symbolBefore = priceText.trim().startsWith(symbol);

        price.textContent = symbolBefore
          ? `${symbol}${formatted}${currency ? ' ' + currency : ''}`
          : `${formatted}${symbol ? ' ' + symbol : ''}${currency ? ' ' + currency : ''}`;



        if (compare_price) {
          compare_price.innerHTML = compare_at_price;
          if (compare_at_price != '') {
            if (saleBadge) saleBadge.classList.remove('visually-hidden');
          } else {
            if (saleBadge) saleBadge.classList.add('visually-hidden');
          }
        } else {
          if (compare_at_price != '') {
            const comparePriceNew = document.createElement('s');
            comparePriceNew.className += 'price-item price-item--compare';
            comparePriceNew.textContent = compare_at_price;

            const saleBadgeNew = document.createElement('span');
            saleBadgeNew.className += 'badge badge--sale';
            saleBadgeNew.textContent = 'Sale';

            price
              .closest('.price-item--regular')
              .parentNode.insertBefore(comparePriceNew, price.closest('.price-item--regular').nextSibling);

            if (!this.closest('.product-card')) {
              price.closest('.price-item--regular').parentNode.insertBefore(saleBadgeNew, comparePriceNew.nextSibling);
            }
          }
        }        

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let productForm;

    if (this.closest('.product-card')) {
      productForm = this.closest('form');
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      
      const preorderEl = document.getElementById('PreorderProperty');
      if (preorderEl && preorderEl.name) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }
    // Start contact advisor button
    let availabilityMeta = variantAvailabilityMeta.find( v => v.id == this.currentVariant.id).availabilityMetafield;
    if(availabilityMeta == 'CONTACT AN ADVISOR') { 
      //document.querySelector('.contact-advisor-btn').style.display = 'block';
      document.querySelector('.product-form-wrap').classList.add('contact-advisor');
    } else {
      // document.querySelector('.contact-advisor-btn').style.display = 'none';
      document.querySelector('.product-form-wrap').classList.remove('contact-advisor');
    }
    // End contact advisor button

    if (!modifyClass) return;
  }

  setUnavailable() {
    let productForm;
    if (this.closest('.product-card')) {
      productForm = this.closest('form');
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (addButton) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }

    if (addButton.hasAttribute('hidden')) {
      addButton.removeAttribute('hidden');
      setTimeout(() => addButton.setAttribute('hidden', ''), 3000);
    } else {
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);
// Variant radios
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('sold-out');
      } else {
        input.classList.add('sold-out');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios);
// Main drawer
class MainDrawer extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.drawer__trigger');
    this.drawer = this.querySelector('.drawer');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDrawer());
    this.querySelectorAll('.drawer-close').forEach((el) => el.addEventListener('click', () => this.closeDrawer()));
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.openDrawer());
    }

    this.setFocus = debounce((event) => {
      trapFocus(this, this.querySelector('.drawer__container'));
    }, 300);
  }

  openDrawer() {
    this.setFocus();
    this.drawer.classList.add('drawer--active');
    document.body.classList.add('drawer--open');
  }

  closeDrawer() {
    this.drawer.classList.remove('drawer--active');
    setTimeout(() => {
      document.body.classList.remove('drawer--open');
    }, 500);
    document.activeElement.blur();
  }
}
customElements.define('main-drawer', MainDrawer);
// Search drawer
class SearchDrawer extends MainDrawer {
  constructor() {
    super();

    this.setFocus = debounce((event) => {
      trapFocus(this, this.querySelector('.search-drawer'));
      document.getElementById('SearchInput').focus();
    }, 300);

    document.getElementById('SearchDrawerTrigger').addEventListener('click', (e) => {
      this.openDrawer();
      this.setFocus();
      if (!document.getElementById('PREDICTIVESEARCHCSS') && document.getElementById('PREDICTIVESEARCHJS')) {
        this.classList.add('loading');
      }
      if (this.querySelector('predictive-search')) {
        loadScript('predictive-search').catch((error) => {
          console.error(error);
        });
        loadCss('predictive-search')
          .then(() => {
            setTimeout(() => {
              this.classList.remove('loading');
            }, 300);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }
}
customElements.define('search-drawer', SearchDrawer);
// Modal dialog
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.hide());
    this.querySelectorAll('.modal__close').forEach((el) => el.addEventListener('click', () => this.hide()));

    this.trigger = this.querySelector('.modal-trigger');

    if (this.trigger) {
      this.trigger.addEventListener('click', this.show.bind(this));
    }
  }

  hide() {
    console.log('click')
    this.querySelector('dialog').removeAttribute('open');
    this.querySelector('.modal').classList.remove('modal--active');
    document.body.classList.remove('modal--open');
    removeTrapFocus(this);
  }

  show() {
    this.querySelector('dialog').setAttribute('open', '');
    this.querySelector('.modal').classList.add('modal--active');
    document.body.classList.add('modal--open');
    trapFocus(this);
  }
}
customElements.define('modal-dialog', ModalDialog);
// Search dialog
class SearchDialog extends ModalDialog {
  constructor() {
    super();

    const triggers = document.querySelectorAll('.search-trigger');

    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        this.loadAssets();
      });
    });
  }

  loadAssets() {
    this.show();
    setTimeout(() => {
      document.getElementById('SearchInput').focus();
    }, 500);
    if (this.querySelector('predictive-search')) {
      if (!document.getElementById('PREDICTIVESEARCHCSS') && !document.getElementById('PREDICTIVESEARCHJS')) {
        this.classList.add('loading');
      }
      loadScript('predictive-search').catch((error) => {
        console.error(error);
      });
      loadCss('predictive-search')
        .then(() => {
          setTimeout(() => {
            this.classList.remove('loading');
          }, 300);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
customElements.define('search-dialog', SearchDialog);
// Back to top
(function backToTop() {
  const trigger = document.querySelector('.btn--back-to-top');

  if (trigger) {
    const backToTopReveal = (e) => {
      if (window.pageYOffset >= 50) {
        trigger.classList.add('btn--back-to-top__revealed');
      } else {
        trigger.classList.remove('btn--back-to-top__revealed');
      }
    };

    backToTopReveal();
    window.addEventListener('scroll', backToTopReveal);

    trigger.addEventListener('click', (e) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();

// Page transition
window.addEventListener('beforeunload', () => {
  document.body.classList.remove('page-loaded');
  document.body.classList.add('page-unloading');
  setTimeout(() => {
    document.body.classList.remove('page-unloading');
  }, 500)
});
window.addEventListener('DOMContentLoaded', () => {
  document.body.classList.remove('page-unloading');
  document.body.classList.add('page-loaded');
});
window.addEventListener('pageshow', (event) => {
  // Removes unload class when returning to page via history
  if (event.persisted) {
    document.body.classList.remove('page-unloading');
  }
});

const productFormObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadScript('product-form').catch((error) => {
          console.error(error);
        });
        productFormObserver.unobserve(entry.target);
      }
    });
  },
  { rootMargin: '0px 0px 250px 0px' }
);

document.querySelectorAll('[product-form-oberver]').forEach((el) => productFormObserver.observe(el));

// Lazyload images
document.addEventListener('DOMContentLoaded', () => {
  const lazyPictures = Array.from(document.querySelectorAll('.lazy-load'));
  
  if ('IntersectionObserver' in window) {
    const loadObs = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const pic = entry.target;
        pic.querySelectorAll('source').forEach(s => {
          if (s.dataset.srcset) {
            s.srcset = s.dataset.srcset;
            s.removeAttribute('data-srcset');
          }
        });
        pic.classList.add('loaded');
        obs.unobserve(pic);
      });
    }, { rootMargin: '1200px' });
    lazyPictures.forEach(pic => loadObs.observe(pic));
  }
  
  if ('IntersectionObserver' in window) {
    const animObs = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;                
        entry.target.classList.add('animate-fade-in');
        obs.unobserve(entry.target);
      });
    }, {       
      rootMargin: '0px 0px 100px 0px',
      threshold: 0
    });    
    lazyPictures.forEach(pic => animObs.observe(pic));
  }
});

// Slider controls
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.layout-scroll').forEach((wrapper) => {
    // reset scroll on load
    setTimeout(() => (wrapper.scrollLeft = 0), 100);

    const isBibliotheque = !!wrapper.closest('.page-bibliotheque');
    const container = wrapper.closest('.container');
    const btnPrev = container?.querySelector('.layout-scroll__button-prev');
    const btnNext = container?.querySelector('.layout-scroll__button-next');
    const items = Array.from(wrapper.children).filter((el) => !el.classList.contains('spacer'));
    let index = 0;

    // helper: is the entire element within scroll-port?
    function isFullyInView(item) {
      const wrapperRect = wrapper.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      return itemRect.left >= wrapperRect.left &&
             itemRect.right <= wrapperRect.right;
    }

    function updateButtons() {
      // hide prev if first is fully visible
      if (btnPrev) btnPrev.toggleAttribute('hidden', isFullyInView(items[0]));
      // hide next if last is fully visible
      if (btnNext) btnNext.toggleAttribute('hidden', isFullyInView(items[items.length - 1]));
    }

    updateButtons();

    const nextOpts = { inline: isBibliotheque ? 'center' : 'start', block: 'nearest', behavior: 'smooth' };
    const prevOpts = { inline: 'center', block: 'nearest', behavior: 'smooth' };

    btnNext?.addEventListener('click', () => {
      if (index < items.length - 1) {
        index++;
        items[index].scrollIntoView(nextOpts);
        updateButtons();
      }
    });

    btnPrev?.addEventListener('click', () => {
      if (index > 0) {
        index--;
        items[index].scrollIntoView(prevOpts);
        updateButtons();
      }
    });

    // keep buttons in sync on manual scroll
    wrapper.addEventListener('scroll', () => {
      const { left, width } = wrapper.getBoundingClientRect();
      const centerX = left + width / 2;
      let closestIndex = 0, closestDistance = Infinity;

      items.forEach((item, i) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + rect.width / 2;
        const dist = Math.abs(itemCenter - centerX);
        if (dist < closestDistance) {
          closestDistance = dist;
          closestIndex = i;
        }
      });
      
      // always re-check visibility
      updateButtons();
    });
  });
});

// Mobile product card slider
function mobileSlider() {
  document.querySelectorAll('.product-card__media a').forEach((container) => {
    container.addEventListener('scroll', () => {
      const slides = container.querySelectorAll('div');
      if (slides.length < 2) return; // Ensure there is a second slide

      const secondSlide = slides[1]; // The second slide
      const containerScrollLeft = container.scrollLeft;
      const slideLeft = secondSlide.offsetLeft;
      const containerWidth = container.clientWidth;

      // Check if second slide is centered within the viewport
      if (
        containerScrollLeft >= slideLeft - containerWidth / 2 &&
        containerScrollLeft < slideLeft + containerWidth / 2
      ) {
        container
          .closest('.product-card__media')
          .querySelector('.media-pagination')
          .classList.add('second-slide-active');
      } else {
        container
          .closest('.product-card__media')
          .querySelector('.media-pagination')
          .classList.remove('second-slide-active');
      }
    });
  });
}
  
window.addEventListener('DOMContentLoaded', () => {
  mobileSlider();
});